import { Toaster as RHToaster, ToastBar, toast } from 'react-hot-toast';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';

const baseStyle = {
  borderRadius: 8,
  padding: '10px 12px',
  fontSize: '13px',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  lineHeight: '1.4',
  letterSpacing: '0.01em',
  boxShadow: '1px 1.5px 1px 1px rgba(0, 0, 0, 0.33)',
  backdropFilter: 'blur(8px)',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '9px',
  minWidth: '300px',
  maxWidth: '420px',
  borderLeft: '4px solid',
  position: 'relative' as const,
  transition: 'all 0.2s ease',
};

const iconWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  borderRadius: 5,
  flexShrink: 0,
  marginTop: '2px',
};

const closeButtonStyle = {
  position: 'absolute' as const,
  top: 4,
  right: 4,
  color: '#64748B',
  padding: '2px',
};

export function Toaster() {
  return (
    <RHToaster
      position="top-right"
      toastOptions={{
        // [GLOBAL]
        duration: 4000,
        style: baseStyle,

        // [TYPE SPECIFIC]
        success: {
          duration: 2500,
          style: {
            ...baseStyle,
            background: 'linear-gradient(135deg, #E8F5D7 0%, #FFFFFF 65%)',
            color: '#334155',
            borderLeftColor: '#6BAA00',
          },
          icon: (
            <div
              style={{
                ...iconWrapperStyle,
                background: 'rgba(107, 170, 0, 0.15)',
              }}
            >
              <CheckCircleIcon
                sx={{
                  color: '#6BAA00',
                  fontSize: 18,
                }}
              />
            </div>
          ),
        },
        error: {
          duration: 5000,
          style: {
            ...baseStyle,
            background: 'linear-gradient(135deg, #FEE2E2 0%, #FFFFFF 65%)',
            color: '#334155',
            borderLeftColor: '#DC2626',
          },
          icon: (
            <div
              style={{
                ...iconWrapperStyle,
                background: 'rgba(220, 38, 38, 0.15)',
              }}
            >
              <ErrorIcon
                sx={{
                  color: '#DC2626',
                  fontSize: 18,
                }}
              />
            </div>
          ),
        },
        loading: {
          duration: Infinity,
          style: {
            ...baseStyle,
            background: 'linear-gradient(135deg, #DBEAFE 0%, #FFFFFF 65%)',
            color: '#334155',
            borderLeftColor: '#22A7F0',
          },
          icon: (
            <div
              style={{
                ...iconWrapperStyle,
                background: 'rgba(34, 167, 240, 0.15)',
              }}
            >
              <CircularProgress
                size={16}
                thickness={4.5}
                sx={{
                  color: '#22A7F0',
                }}
              />
            </div>
          ),
        },
        custom: {
          duration: 4000,
        },
      }}
    >
      {(activeToast) => (
        <ToastBar
          toast={activeToast}
          style={{
            ...activeToast.style,
            paddingTop: '14px',
            paddingRight: '24px',
          }}
        >
          {({ icon, message }) => (
            <>
              <IconButton
                aria-label="Cerrar notificacion"
                style={closeButtonStyle}
                size="small"
                onClick={() => toast.dismiss(activeToast.id)}
              >
                <CloseIcon sx={{ fontSize: 14 }} />
              </IconButton>
              {icon}
              {message}
            </>
          )}
        </ToastBar>
      )}
    </RHToaster>
  );
}
